<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" LeadsPannel>
            <v-row>
              <v-col cols="12" LEADSPANEL>
                <v-card :loading="loading">
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">shopping_cart</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">{{ i18n["videos_and_articles_settings"] }}</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">{{ i18n["academy_settings"] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class=" py-0">
                        <v-row class="align-center">
                          <v-col cols="12" md="4" class="text-center py-1" BTN>
                            <v-btn
                              color="success"
                              block
                              :loading="loading"
                              :class="`${arabic ? 'arFont' : 'enFont'}`"
                              @click="() => openDialog('articles')">
                              {{ i18n["add_article"] }}
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" BTN>
                            <v-btn
                              color="success"
                              block
                              :loading="loading"
                              :class="`${arabic ? 'arFont' : 'enFont'}`"
                              @click="openDialog('categories')">{{ i18n["add_section"] }}</v-btn>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" BTN>
                            <v-btn
                              color="success"
                              block
                              :loading="loading"
                              :class="`${arabic ? 'arFont' : 'enFont'}`"
                              @click="openDialog('keywords')">{{ i18n["add_keyword"] }}</v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                        <Paging 
                          :resourceSettings="resourceSettings" 
                          :resource="resource"
                          @loadResource="loadResource"
                          @pageByNumber="pageByNumber"
                        />
                      </v-col>
                      <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-1 my-0`" v-for="(d, i) in resource.data" :key="i+'not'">
                        <v-row class="align-center elevation-2">
                          <v-col cols="8" :class="`${arabic?'arFont':'enFont'}`">
                            <div style="font-weight:bold;">{{d.title}}</div>
                            <div>{{d.body}}</div>
                            <div><a :href="d.link">link</a></div>
                          </v-col>
                          <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                            <v-btn color="blue" text @click="editArticle(d)">{{ i18n.edit }}</v-btn>
                          </v-col>
                          <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                            <v-btn color="error" text @click="deleteNotification(d.id)">{{ i18n.delete }}</v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <MultiDialog
      :dialog="dialog"
      :resourceKeys="resourceKeys"
      :resourceSettings="resourceSettings"
      :newResource="newResource"
      @closeDialog="closeDialog"
      @postResource="postResource"
      @getUpload="getUpload"
    />

    <academy-article-form
      :article="newResource"
      :loading="loading"
      :dialog="articleDialog" 
      :keywords="resource.keywords"
      :categories="resource.categories"
      @loadResource="loadResource"
      @updateLoadingState="updateLoadingState"
      @closeDialog="closeDialog"
      @on-update="updateResource"
      @postResource="postResource" 
    />
  </v-container>
</template>

<script>
import Paging from '@/components/Paging'
import json2csv from 'json2csv'
import LeadImport from '@/components/LeadImport'
import axios from 'axios';
import AcademyArticleForm from '../components/AcademyArticleForm.vue';
import MultiDialog from '@/components/multiDialog.vue';
const headers = {'Accept': 'application/json'};

export default {
  components: { LeadImport, Paging, AcademyArticleForm, MultiDialog },
  data() {
    return {
      articleResourceKeys: [
        { name: 'title', label: 'title', type: 'text', fetched: 'title', required: true, readonly: false },
        { name: 'category_id', label: 'category', type: 'select', items: 'categories', data: [], source: 'db', required: true, readonly: false },
        { name: 'keyword_ids', label: 'keywords', type: 'select', items: 'keywords', multiple: true, data: [], source: 'db', required: true, readonly: false },
        { name: 'body', label: 'body', type: 'textarea', fetched: 'body', required: true, readonly: false },
      ],
      section: null,
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      models:{
        articles: [],
        keywords:[],
        categories: [],
      },
      articleDialog:false,
      categoryDialog:false,
      keywordDialog:false,
      newResource:{},
      editing:false,
      deleting:false,
      firstPanel:true,
      secondPanel:false,
      thirdPanel:false,
      selectedPanel:'firstPanel',
      subitems:[
        
      ],
      menu1:false,
      fromDate:null,
      menu2:false,
      toDate:null,
      statuses:[],
      selectedStatus:null,
      file:null,
      import_leads:null,
      excludeUsers:[],
      selectedCountries:[],
      filterUsersBy:null,
      products:[],
      selectedProducts:[],
      selectedUsers:[],
      notification:{},
      count:0,
      categories: [],
      keywords: []
    }
  },
  methods: {
    getUpload({field, value}) {
      this.newResource[field] = value 
    },
    editArticle(article) {
      this.newResource = {...article}
      this.articleDialog = true 
    },
    updateLoadingState(is_loading = false) {
      this.loading = is_loading
    },
    async loadItems() {
      return new Promise(async (res, rej) => {
        let iks = ['categories', 'keywords'];
        
        for (let i = 0; i < iks.length; i++) {
          const f = iks[i];
          let t = this.resource[f]
          this[f] = t
          console.log(this[f]);
        }

        let ks = this.articleResourceKeys.filter(x => x.type == 'select' && x.source == 'db');
        
        (async x => {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items)
            f.data = this.resource[f.items].map(x => {
              return {
                ...x,
                text: x.label ? x.label : x.en ? x.en : 'unknown',
                [`${f.name}_id`]: x.id
              }
            })
          }
          res(true)
        })()

        console.log(this.articleResourceKeys);
      })
    },
    openDialog(section) {
      this.section = section
      this.resourceSettings.resourceName = 'keywords';
      if (['keywords', 'categories'].includes(section)) {
        this.dialog = true
        this.resourceSettings.resourceName = section
      }
      else {
        this.newResource = {}
        this.articleDialog = true
      }
    },
    closeDialog() {
      this.newResource = {}
      this.articleDialog = false
      this.dialog = false
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource: '/help/articles', page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('postResource', {resource: `/help/articles/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    buildFilter(){
      let filter = ``
      
      return filter
    },
    async filterLeads(){
      // console.log('filterLeads')
      await this.loadResource()
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/help/articles' + '?' + this.buildFilter()})
          console.log(this.resource)
          res()
        } else {
          // console.log('search', this.search)
          this.resource = await this.$store.dispatch('postResource', {resource:'/help/articles' + this.buildFilter(), value:{search:this.search}})
          console.log(this.resource)
          res()
        }

        await this.loadItems()

        this.loading = false
        res()
      })
    },
    
    exportSimpleData(data, name){
      let a = json2csv.parse(data)
      // console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'failed_export'
      link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    },
    
    async postResource(resource = null) {
      this.loading = true;
      const settings = resource ? resource : this.newResource;

      await this.$store.dispatch('postResource', {
        resource: this.endpoint,
        value: settings,
      });

      await this.loadResource();

      this.newResource = {};
      this.dialog = false;
      this.loading = false;
    },

    async updateResource(data) {
      return new Promise(async (res, rej) => {
        const settings = data;
        this.loading = true;

        await this.$store.dispatch('putResource', {
          resource: `${this.$route.path}/${settings.id}`,
          value: settings,
        });

        this.loadResource();

        this.newResource = {};

        this.dialog = false;
        this.loading = false;
        res(true);
      });
    },
    async deleteNotification(id) {
      this.loading = true
      let a = await this.$store.dispatch('deleteResource', {resource:`/help/articles/${id}`}) 
      await this.loadResource()
      this.loading = false
    },
    details(){

    }
  },
  computed:{
    endpoint() {
      return {
        'articles': '/help/articles',
        'categories': '/help/categories',
        'keywords': '/help/keywords',
      }[this.section]
    },
    resourceKeys() {
      switch (this.section) {
        case 'keywords':
          return [
            { name: 'label', label: 'label', type: 'text', fetched: 'label', required: true, readonly: false },
            { name: 'slug', label: 'slug', type: 'text', fetched: 'slug', required: true, readonly: false },
          ]
        case 'categories':
          return [
            { name: 'label', label: 'label', type: 'text', fetched: 'label', required: true, readonly: false },
            { name: 'menu_label', label: 'menu_label', type: 'text', fetched: 'label', required: true, readonly: false },
            { name: 'slug', label: 'slug', type: 'text', fetched: 'slug', required: true, readonly: false },
            { name: 'image', label: 'image', type: 'upload', required: false, readonly: false, info: {en: '', ar: ''} },
          ]
      }

      return this.articleResourceKeys
    },
    countries(){
      return this.$store.state.countries
    },
    statuses_obj(){
      return this.$store.state.statuses_obj
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
  },
}
</script>

<style>
</style>